import { isMobile, getDeviceTypes } from '@/services/screen'
import { createRouter, createWebHistory } from 'vue-router'
import MainView from '../views/MainView.vue'
import FiltersView from '../views/FiltersView.vue'
import FilterKitsView from '../views/FilterKitsView.vue'
import CustomOpticsView from '../views/CustomOpticsView.vue'
import AccessoriesView from '../views/AccessoriesView.vue'
import ApplicationsView from '../views/ApplicationsView.vue'
import MountingSolutions from '../views/MountingSolutions.vue'
import CustomProtectiveView from '../views/CustomProtectiveView.vue'
import LensesView from '../views/LensesView.vue'
import SilwirView from '../views/SilwirView.vue'
import QueueView from '../views/QueueView.vue'

import FilterKitsIcon from '@/assets/icons/filter-kits.webp';
import AccessoriesIcon from '@/assets/icons/accessories.webp';
import MountSolutionsIcon from '@/assets/icons/mount-solutions.webp';
import CustomOpticsIcon from '@/assets/icons/custom-optics.webp';
import ApplicationsIcon from '@/assets/icons/applications.webp';
import CustomProtectsIcon from '@/assets/icons/custom-protects.webp';
import BearIcon from '@/assets/icons/bear.svg';

const router = createRouter({
  history: createWebHistory('/'),
  routes: [
    {
      path: '/',
      name: 'home',
      component: MainView,
      backgroundColor: '#fcb834',
      iconClass: 'pi pi-chart-line category-icon',
      additionalIcon: 'pi pi-arrow-up-right category-icon-2',
      meta: {
        title: 'Curve Compare',
      }
    },
    {
      path: '/filters',
      name: 'filters',
      component: FiltersView,
      backgroundColor: '#fcb834',
      iconClass: 'pi pi-image category-icon',
      additionalIcon: 'pi pi-arrow-up-right category-icon-2',
      meta: {
        title: 'Filters',
        hideOnMenu: true,
      }
    },
    {
      path: '/filter-kits',
      name: 'filter-kits',
      component: FilterKitsView,
      backgroundColor: '#fcb834',
      iconImage: FilterKitsIcon,
      additionalIcon: 'pi pi-arrow-up-right category-icon-2',
      meta: {
        title: 'Filter Kits',
      }
    },
    {
      path: '/accessories',
      name: 'accessories',
      component: AccessoriesView,
      backgroundColor: '#fcb834',
      iconImage: AccessoriesIcon,
      additionalIcon: 'pi pi-arrow-up-right category-icon-2',
      meta: {
        title: 'Accessories',
      }
    },
    {
      path: '/mounts',
      name: 'mounts',
      component: MountingSolutions,
      backgroundColor: '#fcb834',
      iconImage: MountSolutionsIcon,
      additionalIcon: 'pi pi-arrow-up-right category-icon-2',
      meta: {
        title: 'Mounting Solutions',
      }
    },
    {
      path: '/custom-optics',
      name: 'custom-optics',
      component: CustomOpticsView,
      backgroundColor: '#fcb834',
      iconImage: CustomOpticsIcon,
      additionalIcon: 'pi pi-arrow-up-right category-icon-2',
      meta: {
        title: 'Custom Optics',
      }
    },
    {
      path: '/applications',
      name: 'applications',
      component: ApplicationsView,
      backgroundColor: '#fcb834',
      iconImage: ApplicationsIcon,
      additionalIcon: 'pi pi-arrow-up-right category-icon-2',
      meta: {
        title: 'Applications',
      }
    },
    {
      path: '/custom-protective-windows',
      name: 'custom-protective-windows',
      component: CustomProtectiveView,
      backgroundColor: '#fcb834',
      iconImage: CustomProtectsIcon,
      additionalIcon: 'pi pi-arrow-up-right category-icon-2',
      meta: {
        title: 'Custom Protective Windows',
      }
    },
    {
      path: '/lenses',
      name: 'lenses',
      component: LensesView,
      backgroundColor: '#fcb834',
      iconImage: CustomProtectsIcon,
      additionalIcon: 'pi pi-arrow-up-right category-icon-2',
      meta: {
        title: 'Lenses',
      }
    },
    {
      path: '/silwir',
      name: 'silwir',
      component: SilwirView,
      backgroundColor: '#fcb834',
      iconImage: BearIcon,
      additionalIcon: 'pi pi-arrow-up-right category-icon-2',
      meta: {
        title: 'SILWIR',
      }
    },
    {
      path: '/queue',
      name: 'queue',
      component: QueueView,
      backgroundColor: '#fcb834',
      iconClass: 'pi pi-image pi-list',
      additionalIcon: 'pi pi-arrow-up-right category-icon-2',
      meta: {
        title: 'Queue',
        hidden: ['isDesktop']
      }
    },
  ]
});

router.beforeEach((to, from, next) => {
  if (!to.matched.length) return next('/');
  if (to.meta.hidden) {
    const currentDevice = getDeviceTypes().filter(item => item.state === true)[0].name;
    if (to.meta.hidden.includes(currentDevice)) return next('/');
  }
  if (isMobile() && to.name !== 'queue') return next('/queue');
  return next();
});

export default router
